import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 12px;
`

export const PatientInfo = styled.div`
  display: grid;
  grid-template-columns: 212px repeat(3, 90px);
  gap: 20px;
  margin-bottom: 40px;
  margin-top: 40px;
`

export const SurgeryWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px 5%;
  width: 100%;
`

export const OpmeWrapper = styled.div`
  margin-top: 32px;
`

export const HospitalizationWrapper = styled.div`
  margin-top: 32px;

  > div {
    display: grid;
    grid-template-columns: 30% 70%;
    gap: 32px;
    margin-bottom: 32px;
  }
`

export const Congelation = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  label {
    font-size: 1.5em;
  }
`

export const ChipContainer = styled.div`
  display: flex;
  flex-direction: column;

  & > div {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    div:not(:last-child) {
      margin-right: 12px;
    }
    & > div {
      margin-top: 10px;
    }
  }

  & > label {
    font-size: ${({ theme }) => theme.font.sizes.large};
    font-weight: 400;
    color: ${({ theme }) => theme.colors.gray};
    cursor: pointer;

    span {
      color: ${({ theme }) => theme.colors.red};
    }
  }
`
export const Buttons = styled.div`
  display: flex;
  margin-top: 30px;
  margin-left: auto;
  justify-content: flex-end;
  button + button {
    margin-left: 5%;
  }
`

export const ExpectedDateWrapper = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  input {
    margin: 0;
  }

  & > label {
    font-size: ${({ theme }) => theme.font.sizes.medium};
    font-weight: 400;
    color: ${({ theme }) => theme.colors.gray};
    cursor: pointer;
    margin-right: 10px;
  }
`

export const DiaryWrapper = styled.div`
  padding: 0;
  display: flex;
  align-items: center;

  input {
    padding: 0;
    margin: 0;
    text-align: center;
  }

  & > label {
    font-size: ${({ theme }) => theme.font.sizes.large};
    font-weight: 400;
    color: ${({ theme }) => theme.colors.gray};
    cursor: pointer;
    margin-right: 10px;

    span {
      color: ${({ theme }) => theme.colors.red};
    }
  }
`
export const SurgeryDocumentsContainer = styled.div`
  margin: 60px 0;
`

export const DocumentsButton = styled.div``

export const DateSuportText = styled.div`
  color: ${({ theme }) => theme.colors.darkGreen};
  background: ${({ theme }) => theme.colors.moreLightGreen};
  width: fit-content;
  font-style: italic;
  padding: 0 10px;
  margin-top: 1rem;
`

export const InlineInfo = styled.div`
  display: flex;
  gap: 12px;
`

type RadioGroupProps = {
  justifyContent?: 'space-between' | 'flex-start' | 'center'
}

export const RadioGroup = styled.div<RadioGroupProps>`
  display: flex;
  flex-wrap: wrap;
  width: fit-content;
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  align-items: flex-start;
  gap: 32px;
  margin-top: 16px;
`
